import { render, staticRenderFns } from "./Subseccion.vue?vue&type=template&id=57296698&"
import script from "./Subseccion.vue?vue&type=script&lang=js&"
export * from "./Subseccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports